import React, { useEffect, useRef, useState } from "react";
import {
  addIconGallery,
  closeIcon,
  deleteIconCircleOrange,
  eyeClose,
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  gallery10,
  gallery11,
  gallery12,
  menuDotsIcon,
  modalCloseIcon,
  moveIocn,
  pinBlack,
  pinIocn,
} from "../../../../../images";
import config from "../../../../../config/config";
import Modal from "react-bootstrap/Modal";
import "./workPlacePopup.scss";
import FileUpload from "../FileUpload/FileUpload";
import { useWindowSize } from "react-use";
import http from "../../../../../helpers/http";
import { toast } from "react-toastify";
import ToastMsg from "../../../../../components/ToastMsg/ToastMsg";
import { useBusinessContext } from "../../../../../context/BusinessAccount/BusinessAccountState";
import WorkPlaceDelete from "./WorkPlaceDelete";
import WorkPlaceRecentlyDeleted from "./WorkPlaceRecentlyDeleted";
import BottomSheetOptions from "../GalleryEditPopups/BottomSheetOptions";
import BlurGalleryImage from "../../../../../components/BlurGalleryImage/BlurGalleryImage";

const WorkPlaceDefaultPopup = (props) => {
  const images = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
  ];

  const { width } = useWindowSize();
  const [columns, setColumns] = useState(4);
  const [showFileUploadPopup, setShowFileUploadPopup] = useState(false);
  const [showMovePopup, setShowMovePopup] = useState(false);
  const deleteVariantRef = useRef(null);
  const [arrangedImages, setArrangedImages] = useState([]);
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  const [showGallerypopupDeleteVariant, setShowGallerypopupDeleteVariant] =
    useState(false);
  const [showGallerypopupRecentlyDeleted, setShowGallerypopupRecentlyDeleted] =
    useState(false);
  const [showGalleryPopupPin, setShowGalleryPopupPin] = useState(false);
  const aws_object_url = config.aws_object_url;
  const baseUrl = config.api_url;
  // const { data: businessData, update: updateBusinessContext } =
  //   useBusinessContext(); // Access context data

  const BusinessContext = useBusinessContext();
  const { data: businessData, update: updateBusinessContext } = BusinessContext;

  // useEffect(() => {
  //   const updateColumns = () => {
  //     if (window.innerWidth > 1200) setColumns(4);
  //     else if (window.innerWidth > 1024) setColumns(4);
  //     else if (window.innerWidth > 768) setColumns(4);
  //     else if (window.innerWidth > 340) setColumns(2);
  //     else setColumns(2);
  //   };

  //   updateColumns();
  //   window.addEventListener("resize", updateColumns);
  //   return () => window.removeEventListener("resize", updateColumns);
  // }, []);

  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth > 1200) setColumns(4);
      else if (window.innerWidth > 1024) setColumns(4);
      else if (window.innerWidth > 768) setColumns(3);
      else if (window.innerWidth > 340) setColumns(2);
      else setColumns(2);
    };

    updateColumns(); // run initially
    window.addEventListener("resize", updateColumns);
    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  useEffect(() => {
    createMasonryLayout(); // re-create when column count changes
  }, [columns, props?.categoryData]);

  // Masonry logic: Use businessData instead of props.data
  const createMasonryLayout = () => {
    const images = props?.data || []; // Prefer context data
    let arranged = Array.from({ length: columns }, () => []);
    let columnHeights = Array(columns).fill(0);

    images.forEach((img) => {
      const shortestColumnIndex = columnHeights.indexOf(
        Math.min(...columnHeights),
      );
      // arranged[shortestColumnIndex].push(
      //   `${aws_object_url}business/${img?.url}`
      // );
      arranged[shortestColumnIndex].push({
        src: `${aws_object_url}business/${img?.url}`,
        width: img?.width,
        height: img?.height,
        blurHash: img?.blurHash,
        visibility: img?.visibility,
      });

      columnHeights[shortestColumnIndex] += 1;
    });
    setArrangedImages(arranged);
    return arranged;
  };

  const handleDeleteImages = async (data) => {
    const imageIds = data.map((it) => it.id);
    const section = "workspace_media";

    const response = await http.put(
      `${baseUrl}/business/soft-delete-images/${props?.categoryData?.data?._id}`,
      { imageIds: data },
    );

    if (response?.data) {
      const allImages = businessData?.[section] || props?.data || [];
      const filteredImages = allImages.filter(
        (image) => !imageIds.includes(image._id),
      );
      const deletedImages = allImages.filter((image) =>
        imageIds.includes(image._id),
      );

      // Update context instead of mutating props
      updateBusinessContext({
        ...businessData,
        [section]: filteredImages,
        recently_deleted: {
          ...(businessData.recently_deleted || {}),
          [section]: [
            ...(businessData.recently_deleted?.[section] || []),
            ...deletedImages,
          ],
        },
      });

      createMasonryLayout();
      handleGallerypopupDeleteVariantClose();
      if (
        deleteVariantRef.current &&
        deleteVariantRef.current.handleShowDeletePopupClose
      ) {
        deleteVariantRef.current.handleShowDeletePopupClose();
      }
      toast(
        <ToastMsg message="Image(s) deleted. You can restore them within 30 days." />,
        config.success_toast_config,
      );
      deleteVariantRef.current.resetCheckedItems();
      setShowGallerypopupDeleteVariant(false);
    }
  };

  const handleRestoreImages = async (data) => {
    const imageIds = data.map((it) => it.id);
    const section = "workspace_media";
    const response = await http.put(`${baseUrl}/business/restore-images`, {
      imageIds: data,
    });

    if (response?.data) {
      const restoredImages = props?.recentlyDeletedData?.[section]?.filter(
        (image) => imageIds.includes(image._id),
      );

      const filteredImages = props?.recentlyDeletedData?.[section]?.filter(
        (image) => !imageIds.includes(image._id),
      );
      const updatedSectionImages = [
        ...(businessData?.[section] || []),
        ...restoredImages,
      ];

      updateBusinessContext({
        ...businessData,
        recently_deleted: {
          ...businessData.recently_deleted,
          [section]: filteredImages,
        },
        [section]: updatedSectionImages,
      });

      createMasonryLayout();
      handleGallerypopupDeleteVariantClose();
      if (
        deleteVariantRef.current &&
        deleteVariantRef.current.handleShowDeletePopupClose
      ) {
        deleteVariantRef.current.handleShowDeletePopupClose();
      }
      toast(
        <ToastMsg message="Image(s) restored successfully." />,
        config.success_toast_config,
      );
      setShowGallerypopupRecentlyDeleted(false);
    }
  };

  const handlePermananentDeleteImages = async (data) => {
    const imageIds = data.map((it) => it.id);
    const section = "workspace_media";
    const response = await http.put(`${baseUrl}/business/delete-images`, {
      imageIds: data,
    });

    if (response?.data) {
      const allImages = businessData?.recently_deleted?.[section] || [];
      const filteredImages = allImages.filter(
        (image) => !imageIds.includes(image._id),
      );
      // Update context instead of mutating props
      updateBusinessContext({
        ...businessData,
        recently_deleted: {
          ...(businessData.recently_deleted || {}),
          [section]: filteredImages,
        },
      });

      createMasonryLayout();
      // handleRecentlyDeletedPopupClose();
      if (
        deleteVariantRef.current &&
        deleteVariantRef.current.handleShowDeletePopupClose
      ) {
        deleteVariantRef.current.handleShowDeletePopupClose();
      }
      toast(
        <ToastMsg message="Image(s) deleted. You can restore them within 30 days." />,
        config.success_toast_config,
      );
      deleteVariantRef.current.resetCheckedItems();
      setShowGallerypopupDeleteVariant(false);
    }
  };

  const handleUpdateData = (updatedData) => {
    const section = "workspace_media";

    updateBusinessContext({
      ...businessData,
      [section]: updatedData[section],
    });
    createMasonryLayout();
  };

  const [isHovered, setIsHovered] = useState(false);
  const menuRef = useRef(null);
  const handleFileUploadPopupOpen = () => setShowFileUploadPopup(true);
  // const handleFileUploadPopupClose = () => setShowFileUploadPopup(false);
  const handleFileUploadPopupClose = async () => {
    const updatedData = await BusinessContext.fetchData(
      BusinessContext?.data?._id,
    );
    handleUpdateData(updatedData);
    setShowFileUploadPopup(false);
  };

  const handleRecentlyDeletedPopupOpen = () =>
    setShowGallerypopupRecentlyDeleted(true);
  const handleRecentlyDeletedPopupClose = () =>
    setShowGallerypopupRecentlyDeleted(false);
  const handleGallerypopupDeleteVariantOpen = () =>
    setShowGallerypopupDeleteVariant(true);
  const handleGallerypopupDeleteVariantClose = () =>
    setShowGallerypopupDeleteVariant(false);
  const handleOptionsPopupOpen = () => setShowOptionsPopup(true);
  const handleOptionsPopupClose = () => setShowOptionsPopup(false);

  useEffect(() => {
    createMasonryLayout();
  }, [businessData, props?.data, columns]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsHovered(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      {width <= 768 && (
        <BottomSheetOptions
          theme={props.theme}
          show={showOptionsPopup}
          handleClose={handleOptionsPopupClose}
          handelOpenDelete={handleGallerypopupDeleteVariantOpen}
          handelOpenRecentlyDeleted={handleRecentlyDeletedPopupOpen}
          workplaceBottomSheet={true}
          contactPopup={true}
        />
      )}

      <FileUpload
        theme={props.theme}
        show={showFileUploadPopup}
        handleCloseAndUpdate={handleFileUploadPopupClose}
        headingSugested={`Add More Workplace Images`}
        categoryData={props?.categoryData}
        category={"workspace_media"}
        onUpdateData={handleUpdateData}
      />
      <WorkPlaceDelete
        theme={props.theme}
        show={showGallerypopupDeleteVariant}
        handleCloseDelete={handleGallerypopupDeleteVariantClose}
        categoryData={props?.data}
        onDeleteImages={handleDeleteImages}
        ref={deleteVariantRef}
      />
      <WorkPlaceRecentlyDeleted
        show={showGallerypopupRecentlyDeleted}
        handleCloseDelete={handleRecentlyDeletedPopupClose}
        data={props?.recentlyDeletedData}
        onDeleteImages={handlePermananentDeleteImages}
        onRestoreImages={handleRestoreImages}
        ref={deleteVariantRef}
      />
      <Modal
        {...props}
        centered
        // className="Gallery_popup_modal gallery_popup_edit"
        className={`Gallery_popup_modal gallery_popup_edit ${
          props.theme === "dark" && "nw_gl_popup--dark-mode"
        }`}
        backdropClassName="custom-backdrop-gallery-edit"
        fullscreen={true}
      >
        <Modal.Header>
          <button className="custom-cancel-btn" onClick={props.handleClose}>
            <img
              src={modalCloseIcon}
              alt="close-icon"
              className="ctm_img_bussine_edit_about"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <h2 className="Gallery_popup_heading d-flex align-items-center pb-2">
       {  props.isEditable ? "Edit Workplace Images" : "Workplace Images"}  
            <div
              className="menu-wrapper"
              ref={menuRef}
              onClick={
                width <= 768
                  ? handleOptionsPopupOpen
                  : () => setIsHovered(!isHovered)
              }
            >
              {props.isEditable && (
                <div className="three-dot-icon">
                  <img
                    src={menuDotsIcon}
                    alt="menu"
                    className="menu_gallery_popup_edit_icon"
                  />
                </div>
              )}

              <div className={`hover-menu ${isHovered ? "show" : "hide"}`}>
                <div
                  className="menu-item"
                  onClick={handleGallerypopupDeleteVariantOpen}
                >
                  <img
                    src={deleteIconCircleOrange}
                    alt=""
                    className="menu_icon_popup"
                  />
                  Delete Images
                </div>
                <div
                  className="menu-item border-0"
                  onClick={handleRecentlyDeletedPopupOpen}
                >
                  Recently Deleted
                </div>
              </div>
            </div>
          </h2>

          <div className="masonry-gallery-two">
            {arrangedImages.map((column, colIndex) => (
              <div className="masonry-column" key={colIndex}>
                {/* {column.map((src, index) => (
                  <div className="masonry-item position-relative" key={index}>
                    <div
                      className="img-skeleton-bg"
                      style={{
                        aspectRatio: "auto",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Gallery ${index}`}
                        loading="lazy"
                        decoding="async"
                        onLoad={(e) => {
                          // Set parent height based on loaded image
                          const imgHeight = e.target.offsetHeight;
                          e.target.parentElement.style.minHeight = `${imgHeight}px`;
                        }}
                      />
                    </div>
                  </div>
                ))} */}
                {column.map((item, index) => (
                  <div className="masonry-item position-relative" key={index}>
                    <BlurGalleryImage
                      item={{
                        src: item.src,
                        width: item.width,
                        height: item.height,
                        blurHash: item.blurHash,
                        visibility: item.visibility,
                      }}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>

          {props.isEditable && (
            <div
              className="addMore_gallery_image"
              onClick={handleFileUploadPopupOpen}
            >
              <div className="addMore_wrapper">
                <img
                  src={addIconGallery}
                  alt="add more"
                  className="addMore_icon"
                />
                Add More
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WorkPlaceDefaultPopup;
